import React from "react";
import { Instagram, Youtube, Linkedin, Facebook } from "lucide-react";

const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/healingwithpriyanka_?igsh=MXI3Mm5vdnkwaWRhdg==", Icon: Instagram },
  { label: "LinkedIn",  href: "https://www.linkedin.com/in/prriyanka-dora-2ba119281", Icon: Linkedin },
  { label: "Facebook",  href: "https://www.facebook.com/share/196UBVqwaw/", Icon: Facebook },
  { label: "YouTube",   href: "https://youtube.com/@prriyankadora991?si=F0jVzN3Tlw8QQpj3", Icon: Youtube },
];

export default function Footer({ brand }) {
  const note = brand?.footer_note || "Live healing & manifestation coaching with Prriyanka Dora. Come home to yourself.";
  return (
    <footer className="pt-14 pb-8" style={{ background: "var(--ev-bg-2)" }}>
      <div className="mx-auto max-w-[1200px] px-5 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-8">
          <div className="font-serif-ev text-3xl md:text-4xl" style={{ color: "var(--ev-blue-2)" }}>
            Evolonef
          </div>
          <p className="mt-4 text-sm max-w-sm" style={{ color: "var(--ev-muted)" }}>
            {note}
          </p>
          <div className="mt-6">
            <div className="eyebrow mb-3">Follow along</div>
            <div className="flex items-center gap-3 flex-wrap">
              {SOCIALS.map(({ label, href, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`social-${label.toLowerCase()}`}
                  className="w-10 h-10 rounded-full grid place-items-center border hairline bg-white smooth-hover hover:bg-[color:var(--ev-blue-2)] hover:text-white transition-colors"
                  style={{ color: "var(--ev-blue-2)" }}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="md:col-span-4">
          <div className="eyebrow mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#needs">Your Needs</a></li>
            <li><a href="#coaching">Coaching</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#reviews">Reviews</a></li>
            <li><a href="#faq">FAQ</a></li>
          </ul>
        </div>
      </div>
      <div className="mx-auto max-w-[1200px] px-5 md:px-10 mt-10 pt-6 border-t hairline text-xs text-center" style={{ color: "var(--ev-muted)" }}>
        © {new Date().getFullYear()} Evolonef. All rights reserved.
      </div>
    </footer>
  );
}
